import { ActionsUnion } from '../types';
import { createAction } from '../../utils/action';
import ActionTypes from '../actionTypes';
import { RestErrorResponse } from '../../types/response/RestErrorResponse';
import { ExternalUser, ExternalUserProfileDetails, InternalUser } from './types';

export const Actions = {
  getInternalUsers: () => createAction(ActionTypes.GET_INTERNAL_USERS),
  getInternalUsersSuccess: (users: InternalUser[]) => createAction(ActionTypes.GET_INTERNAL_USERS_SUCCESS, users),
  getInternalUsersError: (error: RestErrorResponse) => createAction(ActionTypes.GET_INTERNAL_USERS_ERROR, error),

  setInternalUsers: (users: InternalUser[]) => createAction(ActionTypes.SET_INTERNAL_USERS, users),

  getExternalUsers: () => createAction(ActionTypes.GET_EXTERNAL_USERS),
  getExternalUsersSuccess: (users: ExternalUser[]) => createAction(ActionTypes.GET_EXTERNAL_USERS_SUCCESS, users),
  getExternalUsersError: (error: RestErrorResponse) => createAction(ActionTypes.GET_EXTERNAL_USERS_ERROR, error),

  getExternalUserProfileDetails: () => createAction(ActionTypes.GET_EXTERNAL_USER_PROFILE_DETAILS),
  getExternalUserProfileDetailsSuccess: (externalUserProfileDetails: ExternalUserProfileDetails) =>
    createAction(ActionTypes.GET_EXTERNAL_USER_PROFILE_DETAILS_SUCCESS, externalUserProfileDetails),
  getExternalUserProfileDetailsError: (error: RestErrorResponse) => createAction(ActionTypes.GET_EXTERNAL_USER_PROFILE_DETAILS_ERROR, error),

  updateExternalUserProfileDetails: () => createAction(ActionTypes.UPDATE_EXTERNAL_USER_PROFILE_DETAILS),
  updateExternalUserProfileDetailsSuccess: () => createAction(ActionTypes.UPDATE_EXTERNAL_USER_PROFILE_DETAILS_SUCCESS),
  updateExternalUserProfileDetailsError: (error: RestErrorResponse) => createAction(ActionTypes.UPDATE_EXTERNAL_USER_PROFILE_DETAILS_ERROR, error),

  updateInternalUserRole: () => createAction(ActionTypes.UPDATE_INTERNAL_USER_ROLE),
  updateInternalUserRoleSuccess: () => createAction(ActionTypes.UPDATE_INTERNAL_USER_ROLE_SUCCESS),
  updateInternalUserRoleError: (error: RestErrorResponse) => createAction(ActionTypes.UPDATE_INTERNAL_USER_ROLE_ERROR, error)
};

export type UsersActions = ActionsUnion<typeof Actions>;
